<template>
	<div>
		<router-link
		  :to="{name: 'serie', params: {id: serie.id, name: serie.name.replaceSpace()}}"
		  style="text-decoration: none"
		>
			<div class="bordero">
				<img :src="serie.image ? serie.image : seriess[Math.round(Math.random() * (seriess.length-1))].image"/>
				<p class="lg">
					{{ serie.name }}
				</p>
			</div>
		</router-link>
	</div>
</template>

<script>
export default {
	name: 'seriesCard',
	props: ['serie'],

	computed:{
		seriess(){
			return	[
				{
					name: 'سلسلة العلوم الاساسية',
					image: '/assets/Icons/1.png',
				},
				{
					name: 'سلسلة العلوم الطبية',
					image: '/assets/Icons/2.png',
				},
				{
					name: 'سلسلة الهندسة الكهرومكانيكية والمعلوماتية',
					image: '/assets/Icons/3.png',
				},
				{
					name: 'سلسلة الهندسة المدنية والمعمارية والبيئية',
					image: '/assets/Icons/4.png',
				},
				{
					name: 'سلسلة العلوم الزراعية',
					image: '/assets/Icons/5.png',
				},
				{
					name: 'سلسلة الآداب والعلوم الانسنية والتربوية',
					image: '/assets/Icons/6.png',
				},
				{
					name: 'سلسلة العلوم الاقصادية',
					image: '/assets/Icons/7.png',
				},
				{
					name: 'سلسلة العلوم القانونية والتشريعية',
					image: '/assets/Icons/8.png',
				},
				{
					name: 'سلسلة تاربخ العلوم عند العرب',
					image: '/assets/Icons/9.png',
				}
			]
		}
	}
};
</script>

<style scoped>
.bordero {
	padding: 50px 30px;
	border-radius: 15px;
	cursor: pointer;
	height: 230px;
	display: flex;
	flex-direction: column;
	align-items: center;
	transition: box-shadow .2s;
}
div p {
	font-family: changeMedium;
	text-align: center;
	text-transform: capitalize;
	font-size: 20px;
	width: 100%;
	line-height: 30px;
	max-height: 60px;
	overflow: hidden;
	overflow: hidden;
	margin: auto;
}

div img {
	height: 50px;
	width: 50px;
	margin-bottom: 20px;
}

.bordero:hover {
	-webkit-box-shadow: 1px 3px 35px #c9dfcf;
	box-shadow: 1px 3px 35px #c9dfcf;
}
@media only screen and (max-width: 992px) {
	.bordero {
		padding: 30px 15px;
	}
	div p {
		max-height: 90px;
	}
}
@media only screen and (max-width: 575px) {
	div p {
		font-size: 16px;
	}
}
</style>
